import { TFrameTypeMap, TKeyMap } from "./_type";

export const DBB_FRAME_TYPE_CACHE = '__dbb_frame_type_cache__';
export const BENCHMARK_SYSTEM = "benchmark";
export const BENCHMARK_GAME_CODE = "benchmark";

// 指标注释和指标中英文key映射关系
export const KEY_TYPE_MAP: TKeyMap = {
  "pc_rows": "pcconsole",
  "mobile_rows": "mobile",
  "mobile": "mobile",
  "pc&console": "pcconsole",
};

// 打点映射关系
export const LOG_TYPE_MAP: TKeyMap = {
  "pc": "pc",
  "mobile": "mobile",
  "console": "console",
  "pcconsole": "pc_console",
};

// 获取页面配置的Api
export const PAGE_CONFIG_API = '/api/v2/dashboard/benchmark/getPageConfig';

export const FRAME_TYPE_MAP: TFrameTypeMap = {
  pcconsole: 'PC&Console',
  mobile: 'Mobile'
};

export const FRAME_TYPE_MAP_REVERSE: TFrameTypeMap = {
  'PC&Console': 'pcconsole',
  'Mobile': 'mobile'
};

// 坐标轴格式化映射关系
export const AXISLABEL_FORMATTER_MAP: TKeyMap = {
  int: { type: 'bmk', decimal: 0 },
  oneDecimal: { type: 'bmk', decimal: 1 },
  twoDecimal: { type: 'bmk', decimal: 2 },
  thousandsInit: { type: 'bmk', decimal: 0 },
  thousands1Decimal: { type: 'bmk', decimal: 1 },
  thousands2Decimal: { type: 'bmk', decimal: 2 },
  bmk: { type: 'bmk', decimal: 0 },
  bmk0: { type: 'bmk', decimal: 1 },
  bmk00: { type: 'bmk', decimal: 2 },
  percentInt: { type: 'percent', decimal: 0 },
  percent1Decimal: { type: 'percent', decimal: 1 },
  percent2Decimal: { type: 'percent', decimal: 2 },
};

export const RANGE_FILTER_ARR = ['download', 'pcu', 'revenue'];

// 没有下拉选项的筛选器类型数组
export const NO_OPTIONS_FILTER_TYPE_ARR = ['range'];

// range类筛选器后端传值转换
export const RANGE_FILTER_PARAMS_MAP: any = {
  'percent': 'top_percent',
  'number': 'top_games' 
};
export const STRING_DEFAULT_FILTER_TYPE = ['single', 'singleCascade'];

// 趋势图 series 配置项类型
export interface ChartSeriesConfig {
  nameEn: string;
  nameCn: string;
  dataKey: string;
  color?: string;
  skipFormat?: boolean; // 是否跳过格式化
}

// 默认的趋势图 series 配置
export const DEFAULT_CHART_SERIES_CONFIG: ChartSeriesConfig[] = [
  {
    nameEn: 'Top10%',
    nameCn: '前10%',
    dataKey: 'top10per',
    color: '#5086F3',
  },
  {
    nameEn: 'Median',
    nameCn: '中位数',
    dataKey: 'median',
    color: '#69D19C',
  },
];
